import { ClickLinkInnerHTMLDirective } from './click-link-innerHTML.directive';
import { NgModule } from '@angular/core';
import { EmailPatternValidatorDirective } from './email-pattern-validator.directive';
import { PasswordDirective } from './show-password.directive';
import { EllipsisDirective } from './ellipsis.directive';
import { MaskDirective } from './mask.directive';
import { FileTypeValidatorDirective } from './file-type-validator.directive';
import { TcDateDirective } from './tc-date.directive';
import { ClickOutSideDirective } from './click-out-side.directive';
import { CompareValidatorDirective } from './compare-validator.directive';
import { MobileDirective } from './mobile.directive';
import { OnlyTellNumberDirective } from './only-tell-number.directive';
import { PhoneDirective } from './phone.directive';
import { LimitedPrecisionDirective } from './limited-precision.directive';
import { RequestStatusClassDirective } from './request-status-class.directive';
import { PaymentStatusClassDirective } from './payment-status-class.directive';
import { OnlinePaymentStatusClassDirective } from './online-payment-status-class.directive';
import { ThousandSeperatorDirective } from './thousand-separator.directive';
import { CopyTextDirective } from './copy-text.directive';
import { TcPromiseDirective } from './tc-promis.directive';
import { OnlyNumberDirective } from './onlyNumber.directive';
import { GatewayRequestStatusClassDirective } from './gateway-request-status-class.directive';
import { TicketStatusClassDirective } from '@app/views/pages/tickets/directives/ticket-status-class.directive';
import { MousePressDirective } from './mouse-press.directive';
import { TcFinalPromiseDirective } from './tc-final-promise.directive';

@NgModule({
	imports: [
		RequestStatusClassDirective,
		MousePressDirective,
		PaymentStatusClassDirective,
		ClickOutSideDirective,
		OnlyNumberDirective,
		OnlyTellNumberDirective,
		ClickLinkInnerHTMLDirective,
		CompareValidatorDirective,
		CopyTextDirective,
		EllipsisDirective,
		EmailPatternValidatorDirective,
		FileTypeValidatorDirective,
		GatewayRequestStatusClassDirective,
		LimitedPrecisionDirective,
		MaskDirective,
		MobileDirective,
		OnlinePaymentStatusClassDirective,
		PhoneDirective,
		PasswordDirective,
		TcDateDirective,		
		TcPromiseDirective,
		ThousandSeperatorDirective,
		TicketStatusClassDirective
	],
	declarations: [
	],
	exports: [
		OnlinePaymentStatusClassDirective,
		EmailPatternValidatorDirective,
		RequestStatusClassDirective,
		PaymentStatusClassDirective,
		FileTypeValidatorDirective,
		CompareValidatorDirective,
		ThousandSeperatorDirective,
		LimitedPrecisionDirective,
		OnlyTellNumberDirective,
		ClickOutSideDirective,
		EllipsisDirective,
		PasswordDirective,
		MobileDirective,
		PhoneDirective,
		TcDateDirective,
		MaskDirective,
		ClickLinkInnerHTMLDirective,
		CopyTextDirective,
		TcPromiseDirective,
		OnlyNumberDirective,
		GatewayRequestStatusClassDirective,
		TicketStatusClassDirective,
		MousePressDirective
	]
})
export class DirectivesModule { }
